import ForecastReportArea from "@/components/sales-forecast/forecast-report-area/ForecastReportArea.vue";

// import SalesApprovalAdd from "@/components/master/sales_approval/SalesApprovalAdd.vue";
// import SalesApprovalDetail from "@/components/master/sales_approval/SalesApprovalDetail.vue";
// import SalesApprovalEdit from "@/components/master/sales_approval/SalesApprovalEdit.vue";
// import SalesApprovalUpload from "@/components/master/sales_approval/SalesApprovalUpload.vue";

let routesreportforecastarea = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "ForecastReportAreaIndex",
        component: ForecastReportArea
      },
     
      // {
      //   path: 'add',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "SalesApprovalAdd",
      //   component: SalesApprovalAdd
      // },
    
      // {
      //   path: 'edit/:id',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "SalesApprovalEdit",
      //   component: SalesApprovalEdit
      // },
    
      // {
      //   path: 'detail/:id',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "SalesApprovalDetail",
      //   component: SalesApprovalDetail
      // },
    
      // {
      //   path: 'upload',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "SalesApprovalUpload",
      //   component: SalesApprovalUpload
      // },
  ]
  
  export default routesreportforecastarea
  